export const create360ViewIcon = () => {
  const view360Icon = document.createElement('div');

  view360Icon.className = 'cloudimage-360-view-360-icon';
  view360Icon.innerText = '0%';

  return view360Icon;
};
